import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';

const Root = styled(Vertical).attrs({ gap: 0 })<{ $scrollPercentage: number }>`
  isolation: isolate;
  &:before {
    z-index: -1;
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background: rgba(var(--c-rgb-black), 0.4);
    backdrop-filter: blur(8px);
    opacity: ${({ $scrollPercentage }) => $scrollPercentage};
  }
`;

const FirstRow = styled(SBHorizontal)`
  padding: var(--unit) var(--double-unit);
`;

const PageHeaderTitle = styled.div`
  width: 100%;
`;

export const TransparentMobileWebAppHeader = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [scrollPercentage, setScrollPercentage] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPercentage(
        Math.min(
          1,
          Number((window.scrollY / (ref.current?.clientHeight || 1)).toFixed(2))
        )
      );
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <Root ref={ref} $scrollPercentage={scrollPercentage}>
      <FirstRow>
        <Horizontal>
          <PageHeaderTitle id="page-header-title" />
        </Horizontal>
      </FirstRow>
      <div id="page-header-second-row" />
    </Root>
  );
};
